<div class="custom-datepicker">
  <ng-container *ngIf="!showBothOptions">
    <button mat-stroked-button color="primary" matTooltip="Modo de vista" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
      (click)="calendarVisibility(!isViewMenuOpen())">
      <div class="flex items-center">
        <div class="pr-5">
          <span matBadge="{{total()}}" matBadgeOverlap="false"></span>
        </div>
        <div class="flex flex-col p-2 content-center text-center gap-[3px] min-w-[60px] w-20">
          <span *ngIf="showFuture" class="font-light">V. Futuros</span>
          <span *ngIf="!showFuture" class="font-light">V. Pasados</span>
        </div>

        <mat-icon [svgIcon]="isViewMenuOpen() ? 'arrow_drop_up' : 'arrow_drop_down'"></mat-icon>
      </div>
    </button>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isViewMenuOpen()"
      cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" [cdkConnectedOverlayHasBackdrop]="true"
      (detach)="calendarVisibility(false)" (backdropClick)="calendarVisibility(false)">
      <div
        class="w-[253px] h-[304px] sm:w-[400px] sm:h-[400px] md:w-[600px] md:h-[500px] lg:w-[800px] lg:h-[600px] p-4 bg-white shadow-lg rounded-lg">
        <full-calendar [options]="calendarOptions"></full-calendar>
      </div>
    </ng-template>
  </ng-container>


  <ng-container *ngIf="showBothOptions">
    <button mat-stroked-button color="primary" matTooltip="Seleccionar periodo" [matMenuTriggerFor]="dualMenu"
      (menuOpened)="isOptionsMenuOpen = true; menuOpened.emit()" (menuClosed)="isOptionsMenuOpen = false" [class.btn-loading]="isLoading">
      <div class="flex items-center">
        <div class="pr-1">
          <mat-icon [svgIcon]="'heroicons_outline:calendar'"></mat-icon>
        </div>
        <div class="flex flex-col px-1 py-1 content-center text-center gap-[2px] min-w-[50px]">
          <span class="font-light text-xs">Periodo</span>
          <small class="font-bold text-xs">{{ showFuture ? 'V. Futuros' : 'V. Pasados' }}</small>
        </div>
        <mat-icon [svgIcon]="isOptionsMenuOpen ? 'arrow_drop_up' : 'arrow_drop_down'"></mat-icon>
      </div>
    </button>

    <mat-menu #dualMenu="matMenu">
      <button mat-menu-item (click)="switchMode(false, triggerPast); $event.stopPropagation()" cdkOverlayOrigin
        #triggerPast="cdkOverlayOrigin" [ngClass]="{'font-extrabold text-primary-600': !showFuture}">
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center gap-4">
            <div class="pr-2">
              <span matBadge="{{pastTotal}}" matBadgeOverlap="false" class="badge-spacer"></span>
            </div>
            <span>V. Pasados</span>
          </div>
          <mat-icon *ngIf="!showFuture" class="text-primary-600"
            [svgIcon]="isViewMenuOpen() ? 'arrow_drop_down' : 'arrow_drop_up'">
          </mat-icon>
        </div>
      </button>
      <button mat-menu-item (click)="switchMode(true, triggerFuture); $event.stopPropagation()" cdkOverlayOrigin
        #triggerFuture="cdkOverlayOrigin" [ngClass]="{'font-bold text-primary-600': showFuture}">
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center gap-4">
            <div class="pr-2">
              <span matBadge="{{futureTotal}}" matBadgeOverlap="false" class="badge-spacer"></span>
            </div>
            <span>V. Futuros</span>
          </div>
          <mat-icon *ngIf="showFuture" class="text-primary-600"
            [svgIcon]="isViewMenuOpen() ? 'arrow_drop_down' : 'arrow_drop_up'">
          </mat-icon>
        </div>
      </button>
    </mat-menu>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="activeTrigger"
      [cdkConnectedOverlayOpen]="isViewMenuOpen()" cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
      [cdkConnectedOverlayHasBackdrop]="true" (detach)="calendarVisibility(false)"
      (backdropClick)="calendarVisibility(false)">
      <div
        class="w-[253px] h-[304px] sm:w-[400px] sm:h-[400px] md:w-[600px] md:h-[500px] lg:w-[800px] lg:h-[600px] p-4 bg-white shadow-lg rounded-lg overflow-hidden">
        <full-calendar [options]="calendarOptions"></full-calendar>
      </div>
    </ng-template>
  </ng-container>

</div>

<!-- Popover personalizado con diseño mejorado -->
<mat-menu #popoverMenu="matMenu" [overlapTrigger]="false" class="custom-popover" [xPosition]="'after'"
  [yPosition]="'below'">
  <div class="p-4 min-w-[200px] max-w-[250px] text-center">
    <div class="text-lg font-bold text-primary">{{ currentEventData?.date | date:'mediumDate' }}</div>
    <div class="mt-2 flex flex-col gap-1 text-sm text-gray-600">
      <!-- Mostrar cada estado con su conteo -->
      <div *ngFor="let status of currentEventData?.statuses">
        <span>{{ status.statusName }}:</span>
        <span class="font-medium" [ngClass]="{
              'text-green-600': status.count.count > 0,
              'text-gray-400': status.count.count === 0
            }">
          {{ status.count.count }}
        </span>
      </div>
      <div>Total: <span class="font-medium">{{ currentEventData?.total }}</span></div>
    </div>
    <button mat-stroked-button color="primary" class="w-full mt-3" (click)="search(currentEventData?.date)">
      Ver detalle
    </button>
  </div>
</mat-menu>

<!-- Botón invisible para disparar el menú -->
<button #popoverTrigger="matMenuTrigger" [matMenuTriggerFor]="popoverMenu"
  style="position: fixed; top: 0; left: 0; opacity: 0; pointer-events: none;"></button>